export const isEmptyValue = value => value === '' || value === undefined;